import React from "react";
import { ButtonLink } from "../../../components/ui/button";
import type { CredentialSharePage } from "../types";
import { CredentialStatusBadge } from "./CredentialStatusBadge";

type CredentialSharePageProps = {
  credentialShare: CredentialSharePage;
};

export const CredentialShareViewPage: React.FC<CredentialSharePageProps> = ({
  credentialShare,
}) => (
  <div className="mx-auto max-w-3xl px-4 py-12">
    <p className="text-sm font-semibold uppercase tracking-wider text-premium-600">
      {credentialShare.organizationName || "Toolkit"}
    </p>
    <h1 className="mt-2 font-display text-3xl font-bold text-foreground">
      Credentials
    </h1>
    <div className="mt-6">
      <ButtonLink to={credentialShare.pdfHref} variant="outline">
        Download PDF
      </ButtonLink>
    </div>
    <ul className="mt-8 grid gap-6">
      {credentialShare.credentials.map((item) => (
        <li
          key={item.id}
          className="overflow-hidden rounded-2xl border border-border bg-card shadow-sm"
        >
          {item.imageUrl ? (
            <img
              src={item.imageUrl}
              alt=""
              className="h-56 w-full object-cover"
            />
          ) : null}
          <div className="p-6">
            <div className="flex items-start justify-between gap-3">
              <h2 className="font-display text-2xl font-semibold text-foreground">
                {item.name || "Credential"}
              </h2>
              <CredentialStatusBadge status={item.status} />
            </div>
            <dl className="mt-4 grid gap-2 text-sm">
              {item.holderName ? (
                <div>
                  <dt className="text-muted-foreground">Holder</dt>
                  <dd className="font-medium">{item.holderName}</dd>
                </div>
              ) : null}
              {item.issuer ? (
                <div>
                  <dt className="text-muted-foreground">Issuer</dt>
                  <dd className="font-medium">{item.issuer}</dd>
                </div>
              ) : null}
              {item.credentialNumber ? (
                <div>
                  <dt className="text-muted-foreground">Number</dt>
                  <dd className="font-medium">{item.credentialNumber}</dd>
                </div>
              ) : null}
              {item.expiresOn ? (
                <div>
                  <dt className="text-muted-foreground">Expires</dt>
                  <dd className="font-medium">{item.expiresOn}</dd>
                </div>
              ) : null}
            </dl>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export const CredentialShareMissingPage: React.FC = () => (
  <div className="mx-auto max-w-lg px-4 py-24 text-center">
    <h1 className="font-display text-2xl font-semibold text-foreground">
      This link is off
    </h1>
    <p className="mt-3 text-muted-foreground">
      The share link is turned off. Ask the owner to turn it back on — the URL
      stays the same.
    </p>
  </div>
);
